import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Home from './pages/home';
import AboutMe from './pages/about-me';
import Contact from './pages/contact';
import DeathCompanionship from './pages/death-companionship';
import MyPractice from './pages/my-practice';
import RitualArts from './pages/ritual-arts';
import RootLayout from './RootLayout';


const router = createBrowserRouter([{
  element: <RootLayout />,
  children: [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/my-practice",
      element: <MyPractice />,
    },
    {
      path: "/about-me",
      element: <AboutMe />,
    },
    {
      path: "/contact",
      element: <Contact />,
    },
    {
      path: "/death-companionship",
      element: <DeathCompanionship />,
    },
    {
      path: "/ritual-arts",
      element: <RitualArts />,
    },
  ]
}]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
